/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef } from 'react';
import type {
  ComponentType,
  ForwardedRef,
  ReactElement,
  Ref,
} from 'react';

import { DebounceInput } from 'react-debounce-input';

import type {
  DebounceInputProps,
} from './types';

function InputComponentInner<
InputComponent extends ComponentType<any> | keyof JSX.IntrinsicElements = 'input',
WrappedComponent = HTMLInputElement,
>(
  props: DebounceInputProps<InputComponent, WrappedComponent>,
  ref: ForwardedRef<WrappedComponent>,
): ReactElement {
  // typescript fix
  const RenderComponent = DebounceInput as ComponentType<
  DebounceInputProps<InputComponent, WrappedComponent> & {
    ref?: Ref<WrappedComponent>;
  }>;

  return (
    <RenderComponent
      {...props}
      inputRef={ref}
    />
  );
}

export const InputComponent = forwardRef(InputComponentInner);
